import api from '../../utils/axios';

export interface CuotaCredito {
  Id: number;
  IdCredito: number;
  NumeroCuota: number;
  FechaVencimiento: string;
  ValorCuota: number;
  ValorPagado: number;
  FechaPago: string | null;
  Estado: 'pendiente' | 'pagada' | 'vencida';
}

export interface CreditoVenta {
  Id: number;
  IdVenta: number;
  IdCliente: number;
  MontoTotal: number;
  Saldo: number;
  NumeroCuotas: number;
  ValorCuota: number;
  FechaPrimeraCuota: string;
  IntervaloDias: number;
  Activo: boolean;
  FechaRegistro: string;
  cuotas: CuotaCredito[];
}

export interface ResumenPagoCuota {
  cuotaId: number;
  numeroCuota: number;
  valorAplicado: number;
  saldoAnterior: number;
  saldoNuevo: number;
  completamentePagada: boolean;
}

export interface RespuestaPagoCuota {
  message: string;
  resumen: ResumenPagoCuota[];
  excedente: number;
  credito: {
    id: number;
    saldoAnterior: number;
    saldoNuevo: number;
    activo: boolean;
  };
}

const BASE = '/ventas/credito';

export const CreditoApi = {
  listar: async (): Promise<CreditoVenta[]> => {
    const { data } = await api.get<CreditoVenta[]>(BASE);
    return data;
  },

  obtener: async (id: number): Promise<CreditoVenta> => {
    const { data } = await api.get<CreditoVenta>(`${BASE}/${id}`);
    return data;
  },

  porCliente: async (idCliente: number): Promise<CreditoVenta[]> => {
    const { data } = await api.get<CreditoVenta[]>(`${BASE}/cliente/${idCliente}`);
    return data;
  },

  pagarCuota: async (idCuota: number, valorPagado: number, fechaPago: string): Promise<RespuestaPagoCuota> => {
    const { data } = await api.post<RespuestaPagoCuota>(`${BASE}/cuota/${idCuota}/pagar`, { valorPagado, fechaPago });
    return data;
  },
};
